import Icon from './Icon';

const Close = (props) => (
  <Icon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M7 17.0001L17 7.00006"
      stroke="var(--color-base-fill)"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <path
      d="M7 7.00043L17 17.0004"
      stroke="var(--color-base-fill)"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
  </Icon>
);

export default Close;
